import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { QRCodeSVG } from "qrcode.react";
import { fmtDateTime } from "./visitorUtils";

/** Enlace que abre el detalle de la visita; lo reconoce el escáner y cualquier lector de QR. */
export const visitLabelUrl = (visitId) => `${window.location.origin}/visitors/history?visit=${visitId}`;

/** Extrae el id de visita de un QR de etiqueta, o null si es otro tipo de código. */
export const parseVisitLabel = (raw) => {
  const match = /[?&]visit=([0-9a-f-]{36})/i.exec(raw || "");
  return match ? match[1] : null;
};

const esc = (value) =>
  String(value ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);

const row = (label, value) =>
  value ? `<div class="row"><b>${esc(label)}:</b> <span>${esc(value)}</span></div>` : "";

/** HTML de la etiqueta 4x2 pulgadas con los datos de la entrada y el QR. */
export const buildVisitLabelHtml = (visit, t) => {
  const qr = renderToStaticMarkup(
    createElement(QRCodeSVG, { value: visitLabelUrl(visit.id), size: 512, level: "M", marginSize: 0 })
  );
  const location = [visit.facility_name, visit.destination].filter(Boolean).join(" · ");
  const host = [visit.host_name, visit.host_unit].filter(Boolean).join(" · ");
  return `<!doctype html><html><head><meta charset="utf-8"><title>${esc(visit.visitor_name)}</title>
<style>
  @page { size: 4in 2in; margin: 0; }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  html, body { width: 4in; height: 2in; font-family: Arial, Helvetica, sans-serif; color: #000; }
  .label { width: 4in; height: 2in; padding: 0.12in; display: flex; gap: 0.12in; align-items: center; overflow: hidden; }
  .info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 0.035in; }
  .name { font-size: 17pt; font-weight: 800; line-height: 1.05; color: #1e293b;
          display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  .name.long { font-size: 13pt; }
  .purpose { font-size: 10pt; font-weight: 700; margin-bottom: 0.03in; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .row { font-size: 8.5pt; line-height: 1.2; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .tag { margin-top: 0.04in; font-size: 7pt; font-weight: 700; letter-spacing: 0.08em; }
  .qr { width: 1.7in; height: 1.7in; flex-shrink: 0; }
  .qr svg { width: 100%; height: 100%; display: block; }
</style></head><body><div class="label">
  <div class="info">
    <div class="name${(visit.visitor_name || "").length > 18 ? " long" : ""}">${esc(visit.visitor_name)}</div>
    <div class="purpose">${esc(visit.purpose || t("visitors.label.generalVisit"))}</div>
    ${row(t("visitors.label.visiting"), host)}
    ${row(t("visitors.label.location"), location)}
    ${row(t("visitors.label.date"), fmtDateTime(visit.check_in_at))}
    ${row(t("visitors.label.document"), visit.visitor_id_number)}
    ${row(t("visitors.label.vehicle"), visit.vehicle?.plate)}
    <div class="tag">${esc(t("visitors.label.visitor"))} · ${esc(visit.id.slice(0, 8).toUpperCase())}</div>
  </div>
  <div class="qr">${qr}</div>
</div></body></html>`;
};

/** Imprime la etiqueta con el diálogo de impresión del navegador (iframe oculto). */
export const printVisitLabel = (visit, t) => {
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
  document.body.appendChild(frame);
  const remove = () => setTimeout(() => frame.remove(), 500);
  const doc = frame.contentWindow.document;
  doc.open();
  doc.write(buildVisitLabelHtml(visit, t));
  doc.close();
  setTimeout(() => {
    frame.contentWindow.addEventListener("afterprint", remove);
    frame.contentWindow.focus();
    frame.contentWindow.print();
    // Respaldo por si el navegador no emite afterprint
    setTimeout(() => frame.isConnected && frame.remove(), 120000);
  }, 150);
};
